import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_111: DocMigration = {
  maxSchemaVersion: "0.0.111",
  description: "Multiple gable roof openings",
  apply(json: any) {
    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];

      if (roof.gableOpenings) {
        roof.gableOpenings = [roof.gableOpenings];
      }

      if (roof.dormers) {
        roof.dormers = [roof.dormers];
      }
    }

    return json;
  },
};

export default migration_0_0_111;
